module.exports = __webpack_public_path__ + "static/media/mongodb.20d8652c.png";